// React
import React, {Component} from 'react';
// Styles
import './styles.scss';
// Components
import {Button} from '@components/Input';
// Helpers
import {isBannerShow} from "@helpers";
// Svg
import {infoSvg} from "@assets";

export class MobileInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        }
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.setState({width: window.innerWidth})
    }

    isVisible = (platform) => {
        const {width} = this.state;
        return ['admin', 'centribot'].includes(platform) && width < 800 && !window.location.href.includes('academy');
    }

    render() {
        const {t, user, plan} = this.props;
        return (
            this.isVisible(process.env.REACT_APP_PLATFORM) &&
            <div className={`platform_mobile_info ${isBannerShow(user, plan) ? 'banner' : ''}`}>
                <span className={"platform_mobile_info__img"}>{infoSvg()}</span>
                <span>{t('commons:mobile.info.title')}</span>
                <span>{t('commons:mobile.info.description')}</span>
                <Button type={"success"} onClick={() => window.location.href = `${process.env.REACT_APP_URL_CENTRIBOT}/academy`} text={t('commons:mobile.info.button')} />
            </div>
        );
    }
}
